import React, { useRef, useEffect } from "react";

//ASSETS
import Honeycomb from "../../assets/honeycomb.svg";

const HoneycombImg = ({
  setBottomOffsetTitle,
  setLeftPositionHoneycomb,
  bottomOffsetTitle,
  isSticky,
}) => {
  const refHoneycomb = useRef();
  const startScrollValue = useRef();

  const handleScroll = () => {
    const deg = ((window.scrollY - startScrollValue.current) * 0.1) % 360;

    if (refHoneycomb.current) {
      if (isSticky) {
        refHoneycomb.current.style.transform = `rotate(${deg + 180}deg)`;
      } else {
        refHoneycomb.current.style.transform = `rotate(${180}deg)`;
      }
    }
  };

  useEffect(() => {
    if (refHoneycomb.current) {
      refHoneycomb.current.onload = (event) => {
        const HoneycombSize = event.target.height;
        setBottomOffsetTitle(HoneycombSize + 160);

        const halfWidthHoneycomb = event.target.width / 2;
        setLeftPositionHoneycomb(halfWidthHoneycomb);
      };
    }

    startScrollValue.current = window.scrollY;

    document.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, [
    bottomOffsetTitle,
    setBottomOffsetTitle,
    setLeftPositionHoneycomb,
    isSticky,
  ]);

  return (
    <div>
      {/* This div isn't used but need to have the pt-48 class on run build */}
      <div className="pt-48 hidden" />
      <img
        ref={refHoneycomb}
        className="w-full"
        src={Honeycomb}
        alt="Honeycomb"
      />
    </div>
  );
};

export default HoneycombImg;
